const dynamicVariables = [
  {
    key_name: 'body_style',
    parent: 'Model',
    type: 'bodyStyle',
  },
];

const abandonData = {
  Model: {
    model_name: '',
    model_year: '',
  },
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
    {
      key_name: 'action_category',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name] request a quote form',
    },
    {
      key_name: 'action_label',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name]:form:raq abandon',
    },
  ],
  'Event Metadata': {
    action_type: 'cta',
  },
};

const submitErrorData = {
  Model: {
    model_name: '',
    model_year: '',
  },
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
    {
      key_name: 'action_category',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name] request a quote form',
    },
    {
      key_name: 'action_label',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name]:form:raq submit invalid ',
    },
  ],
  'Event Metadata': {
    action_type: 'cta',
  },
};

const selectVehicleCtaData = {
  Model: {
    model_name: 'no model',
    model_year: 'no model',
    body_style: 'no model',
  },
  'Event Metadata': {
    action_category: '',
    action_type: 'selector',
    action_label: '',
  },
};

const modelSelectorFilterData = {
  Model: {
    model_name: '',
    model_year: '',
  },
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
  ],
  'Event Metadata': {
    action_category: '',
    action_type: 'selector',
    action_label: '',
  },
};

const packageSelectorFilterData = {
  Model: {
    model_name: '',
    model_year: '',
    model_trim: '',
  },
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
  ],
  'Event Metadata': {
    action_category: '',
    action_type: 'selector',
    action_label: '',
  },
};

const formSubmitButtonData = {
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
    {
      key_name: 'action_category',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name] request a quote form',
    },
  ],
  'Event Metadata': {
    action_type: 'cta',
    action_label: '',
  },
};

const changeDealerCtaData = {
  Model: {
    model_name: '',
    model_year: '',
  },
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
  ],
  'Event Metadata': {
    action_category: 'raq modal',
    action_type: 'cta',
    action_label: '',
  },
};

const genericPageload = {
  Page: {
    site_section: 'shopping tools',
    sub_section3: 'raq modal',
  },
  'Event Metadata': {
    tms_event: 'request_quote_view',
  },
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
  ],
};

const raqStandalonePageload = {
  'Event Metadata': {
    tms_event: 'request_quote_view',
  },
  Model: {
    model_name: 'no model',
    model_year: 'no model',
  },
  Page: {
    page_name: 'raq standalone',
    site_section: 'shopping tools',
    sub_section: 'request a quote',
    sub_section2: 'request a quote form',
  },
};

const preferredDealerData = {
  Model: {
    model_name: '',
    model_year: '',
  },
  dynamic_variables: [
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
    {
      key_name: 'action_category',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name] results',
    },
    {
      key_name: 'action_label',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name]:results:',
    },
  ],
  'Event Metadata': {
    action_type: 'selector',
  },
};

const vehicleCardInteraction = {
  Model: {
  },
  dynamic_variables: [
    {
      key_name: 'action_label',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name]:',
    },
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
    {
      key_name: 'action_category',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name] request a quote form',
    },
  ],
  'Event Metadata': {
    action_type: 'cta',
  },
};

const dealerDirection = {
  'Event Metadata': {
    action_type: 'link',
  },
  Model: {
    model_name: '',
    model_year: '',
  },
  Dealer: {
    selected_dealer_id: '',
    selected_dealer_zipcode: '',
    selected_dealer_name: '',
    selected_dealer_address: '',
  },
  dynamic_variables: [
    {
      key_name: 'action_label',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name]:results:[selected_dealer_name] directions',
    },
    {
      key_name: 'action_category',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name] results',
    },
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
  ],
};

const dealerPhone = {
  'Event Metadata': {
    action_type: 'link',
  },
  Model: {
    model_name: '',
    model_year: '',
  },
  Dealer: {
    selected_dealer_id: '',
    selected_dealer_zipcode: '',
    selected_dealer_name: '',
    selected_dealer_address: '',
    selected_dealer_phone_number: '',
  },
  dynamic_variables: [
    {
      key_name: 'action_label',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name]:results:call [selected_dealer_name]',
    },
    {
      key_name: 'action_category',
      parent: 'Event Metadata',
      type: 'dynamicName',
      search: '[page_name] results',
    },
    {
      key_name: 'body_style',
      parent: 'Model',
      type: 'bodyStyle',
    },
  ],
};

const data = {
  dynamicVariables,
  abandonData,
  submitErrorData,
  selectVehicleCtaData,
  modelSelectorFilterData,
  packageSelectorFilterData,
  formSubmitButtonData,
  changeDealerCtaData,
  preferredDealerData,
  dealerDirection,
  dealerPhone,
  genericPageload,
  raqStandalonePageload,
  vehicleCardInteraction,
};

module.exports = data;
